var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5245_10013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.499 44.998C34.9248 44.998 44.998 34.9248 44.998 22.499C44.998 10.0731 34.9248 0 22.499 0C10.0731 0 0 10.0731 0 22.499C0 34.9248 10.0731 44.998 22.499 44.998Z",
    fill: "#B891E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67977 34.5234C7.67977 34.5234 7.07672 39.2912 4.42169 41.2278C4.18492 41.3998 4.26384 41.7722 4.5512 41.8309C6.49391 42.2255 11.7676 42.5432 17.0432 36.2658",
    fill: "#B891E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9937 24.6971C33.6676 24.6971 34.2119 24.1507 34.2119 23.4789C34.2119 22.807 33.6655 22.2606 32.9937 22.2606H29.6466C29.4624 21.9004 29.2358 21.5766 28.9727 21.2852H32.419C33.0929 21.2852 33.6372 20.7388 33.6372 20.067C33.6372 19.3951 33.0908 18.8488 32.419 18.8488H23.3692C23.9237 18.4521 24.4741 18.0514 25.0144 17.6346C25.409 17.331 25.7166 17.0437 25.8542 16.5418C25.9757 16.1047 25.921 15.5219 25.6701 15.1333C25.4192 14.7428 25.0428 14.3987 24.5773 14.2935C24.1341 14.1923 23.5473 14.1863 23.1689 14.4777C21.7746 15.5522 20.3135 16.5418 18.8706 17.5496C17.9903 18.1648 17.108 18.782 16.2277 19.3972C15.3575 19.5429 14.8193 19.6683 14.8193 19.6683L14.8577 20.3564C14.7262 20.4474 14.5946 20.5405 14.4631 20.6316C14.0665 20.9088 13.7548 21.2448 13.6233 21.7244C13.5019 22.1615 13.5565 22.7443 13.8074 23.1328C14.0584 23.5234 14.4348 23.8674 14.9002 23.9726C14.9508 23.9848 15.0034 23.9929 15.056 24.003L15.4729 31.6302C15.4729 31.6302 16.8065 31.6646 18.6723 31.5108C18.7188 31.5168 18.7654 31.5249 18.8139 31.5249H31.4942C32.168 31.5249 32.7124 30.9785 32.7124 30.3067C32.7124 29.6348 32.166 29.0884 31.4942 29.0884H27.5622C28.0115 28.797 28.4202 28.4733 28.7744 28.113H32.421C33.0949 28.113 33.6392 27.5667 33.6392 26.8948C33.6392 26.2229 33.0929 25.6766 32.421 25.6766H30.1059C30.1687 25.3669 30.2011 25.0432 30.2011 24.7012H32.9937V24.6971Z",
    fill: "#E9DFF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.8844 17.0146H13.2348C11.6724 17.0146 10.4058 18.2813 10.4058 19.8437V29.79C10.4058 31.3524 11.6724 32.619 13.2348 32.619H13.8844C15.4469 32.619 16.7135 31.3524 16.7135 29.79V19.8437C16.7135 18.2813 15.4469 17.0146 13.8844 17.0146Z",
    fill: "#7628C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5245_10013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/thumbs-up.1e6e2acfb724a0758e045327f2338aa6.svg";
export { ForwardRef as ReactComponent };